export enum SmartRoutingStatusEnum {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  INACTIVE = "INACTIVE",
}

export const SmartRoutingStatusColorsEnum: Record<
  string,
  string
> = {
  ACTIVE: "#4caf50",
  PENDING: "#ffc107",
  INACTIVE: "#9e9e9e",
} as const

export const smartRoutingStatusLabels: Record<
  SmartRoutingStatusEnum,
  string
> = {
  [SmartRoutingStatusEnum.ACTIVE]:
    "smartRouting.status.ACTIVE",
  [SmartRoutingStatusEnum.PENDING]:
    "smartRouting.status.PENDING",
  [SmartRoutingStatusEnum.INACTIVE]:
    "smartRouting.status.INACTIVE",
}
